import { signal } from '@preact/signals-react'

export const deviceFormsSignal = signal([])
export const deviceFormsLoadedSignal = signal(false)
export const deviceFormsErrorSignal = signal(null)